<template>
	<div class="" v-if="loading">
		<!-- @click="loading = false" -->
		<div v-loading="loading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"
			style="position: fixed;inset: 0px;z-index: 9999999;top: 0; bottom: 0;right: 0;left: 0;">
		</div>
	</div>
	<el-row :gutter="20" style="flex-wrap: none !important;align-items: normal;margin: 0;">
		<div class="right">
			<div style="height: 100%;background-color: #fff;border-radius: 14px;box-sizing: border-box;padding: 15px;">
				<div class="right-title">
					<el-select class="rw-select" v-model="ckSelectTaskId" filterable
						style="margin-right: 2%;height: 40px;" @change="selectCkRwPl">
						<el-option :label="item.taskName" :value="item.taskId" v-for="(item,index) in ckGlrwList">
						</el-option>
					</el-select>

					<div style="display: flex;justify-content: flex-end;">
						<el-button @click="djYjBtn(true,'AI')" color="#576CD9" type="primary">数据AI预检</el-button>
					</div>
				</div>
				<div class="right-main">
					<el-table :data="tableData" v-loading="tableLoading" ref="multipleTableRef"
						@cell-dblclick="copyDydz" style="width: 100%" highlight-current-row>
						<el-table-column type="index" label="序号" align="center" width="50" />
						<el-table-column prop="local_id" @cell-dblclick="copyDydz" label="识别编号" width="260" />
						<el-table-column prop="task_name" label="任务名称" width="200" />
						<el-table-column prop="storage_path" label="预检路径" />
						<el-table-column prop="add_time" label="添加时间" align="center" width="160" />
						<!-- <el-table-column prop="yjfs" label="预检方式" align="center" width="100" /> -->
						<el-table-column prop="count" label="预检数量" align="center" width="100" />
						<el-table-column prop="save_path_count" label="识别数量" align="center" width="100" />
						<!-- <el-table-column prop="save_path_percentage" label="识别数量" align="center" width="100" /> -->
						<el-table-column prop="yjjd" label="预检进度" align="center" width="200">
							<template v-slot="scope">
								<el-progress :percentage="scope.row.save_path_percentage"></el-progress>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="160">
							<template #default="scope">
								<div style="display: flex;">
									<div v-if="scope.row" @click="userLook(scope.row)" title="查看" class="radius-w"
										style="background-color: #8CABFF;">
										<el-icon>
											<View />
										</el-icon>
									</div>
									<div @click="again(scope.row)" v-if="scope.row.save_path_percentage != '100'"
										title="重新上传" class="radius-w"
										style="background-color: #35AC9E;margin-left: 10px">
										<el-icon>
											<Compass />
										</el-icon>
									</div>
									<div @click="exportDoc(scope.row)" v-if="scope.row.save_path_percentage == '100'"
										title="导出报告" class="radius-w"
										style="background-color: #67C23A;margin-left: 10px;">
										<el-icon>
											<Position />
										</el-icon>
									</div>
									<!-- <div @click="handleEdit(scope.$index, scope.row)" title="修改" class="radius-w"
										style="background-color: #35AC9E;margin: 0 10px;">
										<el-icon>
											<edit />
										</el-icon>
									</div> -->
									<el-popconfirm confirm-button-text="确定" cancel-button-text="取消" icon-color="red"
										v-if="scope.row.over == 0 && userType !=2"
										@confirm="handleDelete(scope.$index, scope.row)" title="确定删除吗?">
										<template #reference>
											<div title="删除" class="radius-w" style="background-color: #CF5B5B;">
												<el-icon>
													<remove />
												</el-icon>
											</div>
										</template>
									</el-popconfirm>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="block" style="display: flex;justify-content: space-between;margin-top: 10px;">
					<el-pagination style="width: 100%;" layout="prev, pager, next,total" :total="tableTotal"
						:page-size="limit" @current-change="changePage"
						v-model:current-page="tableNowPage"></el-pagination>
				</div>
			</div>
		</div>
	</el-row>

	<div v-if="modalName == 'yjsb'"
		style="position: fixed;top: 0;bottom:0;right:0;left:0;background: rgba(0, 0, 0, 0.6);z-index:999;display: flex;justify-content: center;align-items: center;">
		<div class="" @click.stop
			style="width: 600px;background: #ffffff;padding:30px 0 ;border-radius: 10px;display: flex;flex-direction: column;justify-content: center;align-items: center;position: relative;">
			<div class="" style="line-height: 30px;font-size: 18px;">
				<p v-if="yjTitle == 'RG'">人工预检</p>
				<p v-if="yjTitle == 'AI'">AI预检</p>
			</div>
			<div @click="djYjBtn(false)" style="position: absolute;top: 20px;right: 10px;cursor: pointer;">
				<el-icon style="font-size: 20px;">
					<close />
				</el-icon>
			</div>
			<div style="margin-top: 15px">
				<el-select v-model="uploadFistPlData.taskId" placeholder="请选择任务" filterable
					style="width: 505px;height: 40px;" @change="selectGetRwPl">
					<el-option :label="item.taskName" :value="item.taskId" v-for="(item,index) in glrwList"></el-option>
				</el-select>
			</div>
			<div style="margin-top: 15px;display: flex;justify-content: center;">
				<el-input style="width: 300px;" disabled v-model="uploadPath" placeholder="请选择预检路径"></el-input>
				<div class="" style="display: flex;">
					<el-button @click="uploadXzwj" type="primary">
						选择文件
					</el-button>
					<el-button @click="uploadXzml" type="primary">
						选择目录
					</el-button>
				</div>
			</div>
			<div class="">
				<!-- :action="fileUrlPl" -->
				<!-- action="http://127.0.0.1:3333/file/batch" -->

			</div>
			<div class="" id="storagePath2"></div>
			<div style="margin-top: 15px;display: flex;justify-content: center;">
				<el-input style="width: 375px;" disabled class="uoloadParetn2" id="storagePath" v-model="storagePath"
					placeholder="选择文件的存储路径"></el-input>
				<el-button style="width: 130px;display: flex;" @click="downloadMl" type="primary">
					<span class="">选择存储地址</span>
					<!-- <span @click="pasteMl">/粘贴地址</span> -->
				</el-button>
			</div>
			<el-button style="margin-top: 20px;width: 505px;" @click="enableIt('submit')"
				type="primary">开始预检</el-button>
		</div>
	</div>

	<div class="" v-if="modalName == 'yjxq'"
		style="position: fixed;top: 0;bottom:0;right:0;left:0;background: rgba(0, 0, 0, 0.6);z-index:999;display: flex;justify-content: center;align-items: center;">
		<div @click.stop
			style="width: calc(100% - 100px);height: 94vh;;background: #ffffff;padding: 20px;border-radius: 10px;overflow: hidden;position: relative;">
			<div class="" style="line-height: 30px;font-size: 18px;">
				<p>数据预检</p>
			</div>
			<div @click="closeyjxq()" style="position: absolute;top: 20px;right: 10px;cursor: pointer;">
				<el-icon style="font-size: 20px;">
					<close />
				</el-icon>
			</div>
			<div class="" style="display: flex;margin-top: 15px;height: calc(94vh - 50px)">
				<div class="" style="width: 70%;">
					<div class="vanvas-d" style="height: calc(100% - 80px);" ref="vanvas-d">
						<!-- 扫描层 -->
						<div class="shb-smc" v-show="shbSmc"></div>
						<div class="onloadImg">
							<img src="../../public/img/loading.gif" style="width: 100%;height: 100%;">
						</div>
						<canvas id="mycanvas" style="width: 100%;z-index: 9;" ref="mycanvas"></canvas>
						<!-- 右侧弹出 -->
						<div class="BasicTextResult" v-if="dataType != '2'"
							:class="{'close':rightIsOpen,'open':!rightIsOpen}">
							<div class="BasicTextResult-leftIcon">
								<div class="leftIconDiv" @click="collectRight">
									<div
										style="width: 100%;height: 100%;position: absolute;line-height: 100px;color: #FFFFFF;">
										<el-icon v-show="!rightIsOpen">
											<arrow-left-bold />
										</el-icon>
										<el-icon v-show="rightIsOpen">
											<arrow-right-bold />
										</el-icon>
									</div>
								</div>
							</div>
							<div class="BasicTextResult-textResult" v-cloak>
								<div class="basic-text">
									识别结果
								</div>
								<div v-for="(item,i) in ysData" :key="i">
									<div>
										<div class="CentreResult-title">
											{{i>=9?i+1:'0'+(i+1)}}
										</div>
										<div class="CentreResult-Div-titileSpan">
											类目名称
										</div>
										<span class="CentreResult-Div-resultSpan">{{tsType(item[6])}}</span>
									</div>
									<div>
										<div class="CentreResult-Div-titileSpan">
											置信度
										</div>
										<span class="CentreResult-Div-resultSpan">{{zxdNum(item)}}%</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style="display: flex;justify-content: space-between;">
						<!-- v-if="yjTitle == 'AI'" -->
						<div class="eitd-item" :class="{'isEitd-item':eitdItemText == '开始识别'}"
							@click="startIdentification();eitdItemText = '开始识别'">
							<div style="width: 100%;">
								<img style="width: 35px;" src="../../public/img/eitd/01.svg">
								<p>开始识别</p>
							</div>
						</div>
						<div class="eitd-item" @click="reloadCanvas();eitdItemText = '图片复位'"
							:class="{'isEitd-item':eitdItemText == '图片复位'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/02.svg" style="width: 35px;">
								<p>图片复位</p>
							</div>
						</div>

						<div class="eitd-item" @click="tzImg(0);eitdItemText = '拖拽图片'"
							:class="{'isEitd-item':eitdItemText == '拖拽图片'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/03.svg" style="width: 35px;">
								<p>拖拽图片</p>
							</div>
						</div>

						<div class="eitd-item" @click="isMove = false;tzImg(1);eitdItemText = '选中标注'"
							:class="{'isEitd-item':eitdItemText == '选中标注'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/04.svg" style="width: 35px;">
								<p>选中标注</p>
							</div>
						</div>
						<div class="eitd-item" @click="addRect();tzImg(1);eitdItemText = '添加标注'"
							:class="{'isEitd-item':eitdItemText == '添加标注'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/05.svg" style="width: 35px;">
								<p>添加标注</p>
							</div>
						</div>
						<div class="eitd-item" @click="addText();tzImg(1);eitdItemText = '添加文字'"
							:class="{'isEitd-item':eitdItemText == '添加文字'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/06.svg" style="width: 35px;">
								<p>添加文字</p>
							</div>
						</div>
						<div class="eitd-item" @click="delSecect();eitdItemText = '删除选中'"
							:class="{'isEitd-item':eitdItemText == '删除选中'}">
							<div style="width: 100%;">
								<img src="../../public/img/eitd/07.svg" style="width: 35px;">
								<p>删除选中</p>
							</div>
						</div>
					</div>
				</div>
				<div style="width: 30%;padding: 0 20px;">
					<!-- <el-input style="width: 100%;" placeholder="请输入关键字">
						<el-icon class="el-input__icon" @click="searchBtn">
							<search />
						</el-icon>
					</el-input> -->
					<div style="text-align: left;margin-top: 10px;">
						<el-radio-group v-model="dataType" @change="changeType">
							<el-badge :value="ysNum" :max="sbNum" class="item" type="primary">
								<el-radio-button label="1">疑似信息</el-radio-button>
							</el-badge>
							<el-badge :value="wjcNum" :max="sbNum" class="item" type="primary">
								<el-radio-button style="margin-left: 20px;" label="0">未检出</el-radio-button>
							</el-badge>
							<el-badge :value="sbjcNum" :max="sbNum" class="item" type="primary">
								<el-radio-button style="margin-left: 20px;" label="2">上报稽查</el-radio-button>
							</el-badge>
						</el-radio-group>
					</div>

					<!-- <div class="">
						<el-table :data="updataList" style="width: 100%">
							<el-table-column @click="updateIndexAndResetData(index)"
								:style="updataIndex == index?'border:1px solid #409EFF':''" prop="source_path"
								label="文件路径" width="400">
							</el-table-column>
						</el-table>
					</div> -->
					<div class="" v-if="updataList.length>0"
						style="width: 100%;height: calc(100% - 140px);margin-top: 10px;" @scroll="onScroll">
						<div class=""
							style="min-height: 60px;display: flex;border-bottom: 1px solid #f2f2f2;cursor: pointer;border-radius: 6px;align-items: center;padding:6px 10px;"
							@click="updateIndexAndResetData(index)"
							:style="updataIndex == index?'border:1px solid #409EFF':''"
							v-for="(item,index) in updataList">
							<p style="text-align: left;display:flex;align-items: center;"
								:style="dataType == 1?'width: calc(100% - 80px)':'width: 100%'">
								<img :src="item.source_path" style="width: 60px;height: 60px" alt="" srcset="" />
								<text
									style="width: calc(100% - 80px);word-wrap: break-word;margin-left:10px">{{item.source_path}}</text>
							</p>
							<el-button v-if="dataType == 1" @click="remove(index)" size="small" type="primary"
								style="width: 60px;padding: 0;">移交未检</el-button>
						</div>
					</div>
					<div v-else style="width: 100%;height: calc(100% - 140px);margin-top: 10px;">
						无数据
					</div>
					<div class="block" style="display: flex;justify-content: space-between;margin-top: 10px;">
						<el-pagination style="width: 80%;" :pager-count="5" layout="prev, pager, next,total"
							:total="updataTotal" :page-size="updataLimit" @current-change="updataChangePage"
							v-model:current-page="updataNowPage"></el-pagination>
					</div>
					<div style="display: flex;justify-content: space-around;align-items: center;margin-top: 10px;">
						<el-button @click="previous">上一张</el-button>
						<el-button @click="saveCanvas" type="primary" style="width: 200px;">上报至稽查</el-button>
						<el-button @click="nextSheet">下一张</el-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var canvas, startX, startY, endX, endY, movementX = 0,
		movementY = 0;
	var zoom = 1;
	import {
		fabric
	} from 'fabric';
	import {
		io
	} from 'socket.io-client'
	import {
		ElMessage,
		ElLoading
	} from 'element-plus'
	import {
		number
	} from 'echarts';

	import {
		exportWordImage,
		getWordImage
	} from "../utils/exportFile.js";
	import {
		ref
	} from "vue";
	const {
		v4: uuidv4
	} = require('uuid');
	export default {
		data() {
			const validatePass1 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('账号不能为空'))
				} else {
					this.$axios.post('/flight/check', {
							userId: sessionStorage.getItem('userId'),
							type: sessionStorage.getItem('type'),
							account: value
						})
						.then(res => {
							if (res.data.code != 666) {
								callback(new Error(res.data.msg))
								callback()
							}
							callback()
						})
						.catch(error => {
							callback()
							console.log('error:', error)
						})

				}
			}
			const validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入新密码'))
				} else {
					callback()
				}
			}
			return {
				plUpType: '2',
				dataType: 1,
				isTest: true,
				plCheckBtn: false,
				onloadCanvaImg: true,
				plCheckBtnRB: false,
				listCheckOptions: [{
					label: '操作',
					options: [{
						value: 'del',
						label: '批量删除',
					}, ]
				}],
				modalName: '',
				loadingText: '',
				loading: false,
				updataPage: 0,
				updataIndex: 0,
				// source_path: 'https://zcjzcd.com/api/public/storage/2025/05/06/thumb50_17465197720795466_YS-20220420-00016.jpg'
				updataList: [],
				updataLimit: 0,
				updataTotal: 0,
				updataNowPage: 1,
				storagePath: '',
				uploadPath: '',
				upload_local_id: '',
				upload_storage_path: '',
				upload_task_name: '',
				upload_task_id: '',
				fileTree: [],
				yjTitle: '',
				wjcNum: 0,
				sbjcNum: 0,
				ysNum: 0,
				sbNum: 0,
				tableListCheckRB: [],
				tableListCheck: [],
				jcxxImg: [],
				jcForm: {
					checkLevel: "",
					checkNode: "",
					checkState: 0,
					checkTime: "",
					checkUserId: "",
					checkUserName: ""
				},
				plscwz: '准备上传',
				plscwzShow: false,
				tableLoading: false,
				PlprogressNum: 0,
				PlprogressNumBf: 0,
				kssbProgress: false,
				dwjfileList: [],
				uploadTypeTaext: '选择文件',
				dialogPlsc: false,
				BintableTotal: 0,
				BintableNowPage: 1,
				drecycleBinData: [],
				isGetImg: false,
				eitdItemText: '',
				scale_h_percent: 1,
				scale_w_percent: 1,
				getImgData: [],
				listState: 0,
				flieidList: {
					one: '',
					two: '',
					three: ''
				},
				flieRouteList: {
					one: '',
					two: '',
					three: ''
				},
				nowPage: 0,
				canvasData: {
					one: '',
					two: '',
					three: ''
				},
				canvasBackImg: '',
				onloadImg: false,
				showViewer: false,
				showViewerOld: false,
				imgList: [],
				sourceUrlList: [],
				viewerIndex: 0,
				showViewerJc: false,
				imgListJc: [],
				viewerIndexJc: 0,
				ysData: [],
				ysGPS: [],
				sfwk: false,
				shbSmc: false,
				panning: false,
				isMove: false,
				isAdd: false,
				socket: null,
				dialogVisible: false,
				dialogEdit: false,
				uploadBeforeLength: 1,
				pcUploadList: [],
				uploadBeforeList: [],
				nowZoom: 1,
				dialogUrl: '',
				percentage0: 0,
				percentage1: 0,
				percentage2: 0,
				uploadFistPlData: {
					userId: sessionStorage.getItem('userId'),
					type: sessionStorage.getItem('type'),
					userName: sessionStorage.getItem('username'),
					taskId: '',
					taskName: ''
				},
				uploadFistData: {
					userId: sessionStorage.getItem('userId'),
					type: sessionStorage.getItem('type'),
					isCheckFile: 1,
					fileId: ''
				},
				uploadsecData: {
					userId: sessionStorage.getItem('userId'),
					type: sessionStorage.getItem('type'),
					isCheckFile: 0,
					fileId: ''
				},
				fileUrl: process.env.VUE_APP_PUBLICURL + '/file/single',
				fileUrlPl: process.env.VUE_APP_PUBLICURL + '/file/batch',
				drawerTitle: '',
				imageData: {
					url: ''
				},
				imageData1: {
					url: ''
				},
				imageData2: {
					url: ''
				},
				imageUrl1: '',
				imageUrl2: '',
				filterText: '',
				dataSource: [],
				tablekwd: '',
				drawer: false,
				drawerkh: false,
				jcxxImgnUM: 0,
				dialogFormuser: false,
				clickType: 'add',
				khForm: {
					jcwz: '',
					zbxx: '',
					sfqr: 0,
					sldj: '1~50',
					glrw: '',
					glrwName: ''
				},
				userType: sessionStorage.getItem('type'),
				mapList: [],
				map: '',
				mapInpoutOnFocus: false,
				isSaveYs: false,
				editGps: [],
				tableData: [],
				tableTotal: 6,
				limit: 10,
				tableNowPage: 1,
				isEdit: false,
				isLook: false,
				nowCenter: '',
				ckGlrwList: [],
				ckSelectTaskId: '',
				glrwList: [],
				rightIsOpen: false,
				rowData: '',
				wuuid: '',
				imgFile: {
					one: '',
					two: '',
					three: ''
				},
				dhcState: 1,
				canvasSVG: {
					one: '',
					two: '',
					three: ''
				},

			}
		},
		methods: {
			copyDydz(row, column, cell, event) {
				var nowCopy = row[column.property];
				ElMessage({
					message: '已复制到剪切板',
					type: 'success',
					offset: 200
				})
				this.copyText(nowCopy);
			},
			copyText(text) {
				var input = document.createElement('input');
				input.setAttribute('id', 'input_for_copyText');
				input.value = text;
				document.getElementsByTagName('body')[0].appendChild(input);
				document.getElementById('input_for_copyText').select();
				document.execCommand('copy');
				document.getElementById('input_for_copyText').remove();
			},

			selectGetRwPl(vId) {
				let obj = {};
				obj = this.glrwList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.taskId === vId; //筛选出匹配数据
				});
				this.uploadFistPlData.taskName = obj.taskName;
				this.uploadFistPlData.taskId = obj.taskId;
			},


			uploadDwjsc() {
				if (!this.uploadFistPlData.taskId) {
					ElMessage.warning('请选择关联任务!')
					return
				}
				$('.uoloadParetn .el-upload__input').click();
			},
			clickEdit(num) {
				this.dialogEdit = true;
				this.nowPage = num;
			},
			selectCkRwPl(val) {
				this.ckSelectTaskId = val;
				this.getKhList();
			},



			async saveCanvas() {
				try {
					// 1. 获取画布数据（同步操作）
					this.getCanvasData();
					// 2. 上传文件并等待结果
					this.storagePath = this.updataList[this.updataIndex].storage_path
					const upload_result = await this.uploadFile(
						this.updataList[this.updataIndex].source_path,
						this.updataList[this.updataIndex].task_id,
						this.updataList[this.updataIndex].task_name
					);
				} catch (error) {
					console.error('保存流程出错:', error);
					throw error; // 继续向上抛出错误
				}
			},

			async uploadFile(fileUrl, taskId, taskName) {
				this.loadingText = '识别信息上传中，请稍等。。。'
				this.loading = true
				var payload = {
					filePath: fileUrl,
					type: sessionStorage.getItem('type'),
					userId: sessionStorage.getItem('userId'),
					userName: sessionStorage.getItem('username'),
					taskId,
					taskName,
					state: '0',
				}
				window.electron.uploadFile(payload).then((result) => {
					this.setOcrInfo(result, fileUrl)
					ElMessage.success(`图片上传成功`);
					this.loading = false
				}).catch((error) => {
					console.log('失败--' + error)
					ElMessage.error(`上传图片信息失败，请重新上传`);
					this.loading = false
				});
			},

			async setOcrInfo(upload_result, fileUrl) {
				try {
					// 3. 准备检测数据
					const detections = JSON.stringify(this.canvasToImg(canvas.toJSON()));
					const data = JSON.parse(detections);
					// 1. 修改 rect 数组：前4个元素除以2（确保 data.rect 存在且是数组）
					if (Array.isArray(data?.rect)) {
						data.rect = data.rect.map(rect => {
							if (Array.isArray(rect) && rect.length >= 4) {
								return [
									rect[0] / 2,
									rect[1] / 2,
									rect[2] / 2,
									rect[3] / 2,
									...rect.slice(4)
								];
							}
							return rect; // 如果不是有效数组，返回原值
						});
					}

					// 2. 修改 text 数组：前2个元素除以2（确保 data.text 存在且是数组）
					if (Array.isArray(data?.text)) {
						data.text = data.text.map(text => {
							if (Array.isArray(text) && text.length >= 2) {
								return [
									text[0] / 2,
									text[1] / 2,
									...text.slice(2)
								];
							}
							return text; // 如果不是有效数组，返回原值
						});
					}

					// 4. 获取Base64图像
					let base64;
					try {
						base64 = canvas.toDataURL({
							format: 'image/png'
						});
						console.log('生成的Base64:', base64.slice(0, 50) + '...');
					} catch (error) {
						throw new Error(`生成Base64失败: ${error.message}`);
					}

					// 5. 上传OCR信息
					const response = await this.$axios.post('/file/ocrInfo', {
						fileId: upload_result.fileId, // 确保使用uploadFile返回的结果
						dybh: upload_result.dybh,
						data: JSON.stringify(data),
						img: base64,
						sourceType: 'client'
					}, {
						headers: {
							'Content-Type': 'application/json'
						}
					});

					const savePath = await this.saveRectImg(
						this.updataList[this.updataIndex].source_path,
						detections,
						this.storagePath + '\\' + this.local_id
					);
					const update_sql =
						`update records set dybh='${upload_result.dybh}',detection='${detections}',save_path='${savePath}' where local_id='${this.local_id}' and source_path='${fileUrl}'`
					window.electron.update(update_sql)
					this.loading = false
					const selectCount = await window.electron.query(
						"SELECT SUM( CASE WHEN detection = '[]' THEN 1 ELSE 0 END) AS empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh ISNULL THEN 1 ELSE 0 END ) AS non_empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh NOTNULL THEN 1 ELSE 0 END ) AS non_empty_array_count2, COUNT(*) AS total_count FROM records WHERE local_id = '" +
						this.local_id + "'"
					);
					this.wjcNum = selectCount[0].empty_array_count
					this.ysNum = selectCount[0].non_empty_array_count
					this.sbjcNum = selectCount[0].non_empty_array_count2
					this.sbNum = selectCount[0].total_count


					this.updataPage = 0
					this.updataList = []
					this.updataList = await this.getUpdataList()


					setTimeout(() => {
						this.updateIndexAndResetData(this.updataIndex)
					}, 500)

				} catch (error) {
					console.error('上传OCR信息出错:', error);
					ElMessage.error(`上传OCR信息失败: ${error}`);
					throw error;
				}
			},

			async saveRectImg(uploadPath, detections, storagePath) {
				var dataObj = {
					imagePath: uploadPath,
					detections,
					outputDir: storagePath
				}
				console.log(dataObj)
				return window.electron.saveRectImg(dataObj)
			},


			getCanvasData() {
				// 图片复位
				this.reloadCanvas();
			},

			tzImg(num) {
				if (num == 0) {
					this.isMove = true;
					this.isAdd = false;
					var objects = canvas.getObjects();
					for (var i = 0; i < objects.length; i++) {
						objects[i].selectable = false;
					}
				} else {
					var objects = canvas.getObjects();
					for (var i = 0; i < objects.length; i++) {
						objects[i].selectable = true;
					}
				}
			},
			zxdNum(item) {
				// var zxdNum = (item[4] * item[5]) * 100;
				// zxdNum = Math.round(zxdNum)
				return this.truncateToThreeDecimals(item[5])
			},
			tsType(type) {
				if (type == 0) {
					return '罂粟'
				} else if (type == 1) {
					return '有花'
				} else if (type == 2) {
					return '有果'
				} else if (type == 3) {
					return '罂粟苗'
				}
			},

			async onScroll(event) {
				const container = event.target;
				// 添加5px的容差阈值，避免精度问题
				const threshold = 5;
				// 精确计算是否到达底部
				const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - threshold;

				if (isAtBottom) {
					console.log('真正滚动到了底部');
					this.updataPage++
					this.updataList = this.updataList.concat(await this.getUpdataList())
				}
			},
			closeyjxq() {
				this.updataPage = 0
				this.updataList = []
				this.updataIndex = 0
				this.modalName = false
			},
			updateIndexAndResetData(index) {
				this.updataIndex = index;
				this.rightIsOpen = false;
				this.ysData = [];
				var drawUrl = this.dataType == 2 ? this.updataList[this.updataIndex].save_path : this.updataList[this
					.updataIndex].source_path
				this.initDraw(drawUrl, index);
			},
			async remove(index) {
				const fileUrl = this.updataList[index].source_path
				const update_sql =
					`update records set detection='[]' where local_id='${this.local_id}' and source_path='${fileUrl}'`
				window.electron.update(update_sql)
				this.loading = false
				const selectCount = await window.electron.query(
					"SELECT SUM( CASE WHEN detection = '[]' THEN 1 ELSE 0 END) AS empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh ISNULL THEN 1 ELSE 0 END ) AS non_empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh NOTNULL THEN 1 ELSE 0 END ) AS non_empty_array_count2, COUNT(*) AS total_count FROM records WHERE local_id = '" +
					this.local_id + "'"
				);
				this.wjcNum = selectCount[0].empty_array_count
				this.ysNum = selectCount[0].non_empty_array_count
				this.sbjcNum = selectCount[0].non_empty_array_count2
				this.sbNum = selectCount[0].total_count
				this.updataList = []
				this.updataList = await this.getUpdataList()

				this.updateIndexAndResetData(index)
			},
			async startIdentification() {
				this.ysData = [];
				this.shbSmc = true;
				if (canvas) {
					var objects = canvas.getObjects();
					for (var i = 0; i < objects.length; i++) {
						canvas.remove(objects[i])
					}
				}
				var nowImgWidth = 0;
				var nowImgHeight = 0;

				const detections = await window.electron.runInference(this.updataList[this.updataIndex]
					.source_path);

				window.electron.getImageDimensions(this.updataList[this.updataIndex].source_path).then((
					result) => {
					nowImgWidth = result.width;
					nowImgHeight = result.height;
					if (detections) {
						var canvasHis = this.dataType == 2 ? [] : detections
						this.ysData = canvasHis;
						if (canvasHis) {
							console.log('绘制数据')
							for (var i = 0; i < canvasHis.length; i++) {
								this.transformationW(canvasHis[i], nowImgWidth, nowImgHeight, i)
							}
						}
					};
					this.shbSmc = false;
					this.rightIsOpen = true;
				});
			},

			uuid() {
				var s = [];
				var hexDigits = "0123456789abcdef";
				for (var i = 0; i < 32; i++) {
					s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
				}
				s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
				s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
				s[8] = s[13] = s[18] = s[23] = "-";

				var uuid = s.join("");
				this.uploadFistData.fileId = uuid;
				this.uploadsecData.fileId = uuid;
				this.wuuid = uuid;

			},
			lookImg(url) {
				// 查看时不弹出  未加载完缩略图不弹出
				if (this.isLook || this.isGetImg) {
					return
				}
				if (!url) {
					this.dialogEdit = true
				}
			},



			// 图片复位
			reloadCanvas(url) {
				var canvasBackImg = this.canvasBackImg;
				var canvasData = this.canvasToImg(canvas.toJSON());
				if (canvas) {
					// 清空画布
					$('.vanvas-d .canvas-container').remove();
					$('.vanvas-d').prepend(
						'<canvas id="mycanvas" style="border:1px solid #ccc;width: 100%;height: 100%;" ref="mycanvas"></canvas>'
					)
					// 重置偏移量
					movementX = 0;
					movementY = 0;
				}
				// 初始化画布
				canvas = new fabric.Canvas('mycanvas');
				// 设置宽高


				canvas.setHeight($('.vanvas-d').height());
				canvas.setWidth($('.vanvas-d').width());
				// 设置背景
				canvas.setBackgroundImage(canvasBackImg, canvas.renderAll.bind(canvas));
				canvas.renderAll();

				// 绘制对象
				if (canvasData) {
					var canvasHis = canvasData;
					var textD = canvasHis.text;
					canvasHis = canvasHis.rect;
					this.ysData = canvasHis;
					if (canvasHis) {
						for (var i = 0; i < canvasHis.length; i++) {
							this.transformationW(canvasHis[i], canvasBackImg.width, canvasBackImg.height, i)
						}
					}
					if (textD) {
						for (var i = 0; i < textD.length; i++) {
							this.transformaText(textD[i], canvasBackImg.width, canvasBackImg.height)
						}
					}
				};
				// 拖拽
				canvas.on({
					// 鼠标滚动缩放
					"mouse:wheel": (e) => {
						var oldZoom = zoom;
						zoom = (event.deltaY > 0 ? -0.2 : 0.2) + canvas.getZoom();
						zoom = Math.max(1, zoom); //最小为原来的1
						zoom = Math.min(15, zoom); //最大是原来的10倍
						this.nowZoom = zoom;
						// 缩放偏移量
						movementX += (canvas.width / 2) / zoom - (canvas.width / 2) / oldZoom;
						movementY += (canvas.height / 2) / zoom - (canvas.height / 2) / oldZoom;
						// var zoomPoint = new fabric.Point(e.pointer.x, e.pointer.y); // 中心点
						var zoomPoint = new fabric.Point(canvas.width / 2, canvas.height / 2);
						canvas.zoomToPoint(zoomPoint, zoom);
					},
				})

				canvas.on('mouse:up', (e) => {
					this.panning = false;
					endX = e.pointer.x;
					endY = e.pointer.y;
					var widthX = endX - startX > 0 ? endX - startX : startX - endX;
					var heightY = endY - startY > 0 ? endY - startY : startY - endY;
					// 减去背景平移位置
					startX = startX / zoom - movementX;
					startY = startY / zoom - movementY;
					if (this.isAdd) {
						this.addfabric(startX, startY, widthX / zoom, heightY / zoom);
						this.isAdd = false;
					}
				});
				// 鼠标按下
				canvas.on('mouse:down', (e) => {
					this.panning = true;
					startX = e.pointer.x;
					startY = e.pointer.y;
				});
				canvas.on('mouse:move', (e) => {
					if (this.isMove && this.panning && e && e.e) {
						// // console.log(e);
						var units = 10;
						movementX += (e.e.movementX) / zoom;
						movementY += (e.e.movementY) / zoom;
						var delta = new fabric.Point(e.e.movementX, e.e.movementY);
						canvas.relativePan(delta);
					}
				})
				// 取消选中状态
				if (canvas) {
					canvas.discardActiveObject().renderAll();
				}

				movementX = 0;
				movementY = 0;
				this.nowZoom = -1;
				zoom = 1;
			},
			delSecect() {
				canvas.remove(canvas.getActiveObject())
			},
			// 添加文字
			addText() {
				if (this.isLook) {
					return
				}
				this.isMove = false;
				var text = new fabric.Textbox('请在此处输入文字标注', { //绘制文本
					width: 200,
					fontSize: 20,
					left: canvas.width / 2,
					top: canvas.height / 2,
					fill: "blue",
					stroke: 'blue',
					strokeWidth: 0.1,
				});
				canvas.add(text);
				canvas.setActiveObject(text);
			},
			// 添加矩形
			addRect() {
				if (this.isLook) {
					return
				}
				this.isMove = false;
				this.isAdd = true;
			},
			// 保存，对象位置转坐标
			canvasToImg(data) {
				if (!data.objects || data.objects.length == 0) {
					return
				}
				var left0, top0, left1, top1, cdata, zxd0, zxd1, zxd2;
				var canvasData = [];
				var canvasText = [];
				var canvasWidth = $('#mycanvas').width();
				var canvasHeight = $('#mycanvas').height();
				let scale_h_percent = canvasHeight / data.backgroundImage.height;
				let scale_w_percent = canvasWidth / data.backgroundImage.width;
				data = data.objects;
				for (var i = 0; i < data.length; i++) {
					if (data[i].type == 'group') {
						cdata = [];
						left0 = data[i].left + 60;
						top0 = data[i].top + 40;
						left1 = left0 + data[i].objects[0].width;
						top1 = top0 + data[i].objects[0].height;
						if (data[i].backgroundColor) {
							zxd0 = data[i].backgroundColor.split(",")[0];
							zxd1 = data[i].backgroundColor.split(",")[1];
							zxd2 = data[i].backgroundColor.split(",")[2];
						} else {
							zxd0 = 1;
							zxd1 = 1;
							zxd2 = 1;
						}
						cdata.push(left0 / scale_w_percent);
						cdata.push(top0 / scale_h_percent);
						cdata.push(left1 / scale_w_percent);
						cdata.push(top1 / scale_h_percent);
						cdata.push(parseFloat(zxd0));
						cdata.push(parseFloat(zxd1));
						cdata.push(parseFloat(zxd2));
						canvasData.push(cdata)
					} else if (data[i].type == 'textbox') {
						canvasText.push([data[i].left / scale_w_percent, data[i].top / scale_h_percent, data[i].width,
							data[i].text
						]);
					}
				}
				var retData = {
					rect: canvasData,
					text: canvasText
				}
				// console.log(retData);
				return retData
			},
			// 位置转换
			transformationW(data, imgWidth, imgHeight, num) {
				console.log(data)
				console.log(imgWidth)
				console.log(imgHeight)
				console.log(num)
				var left0 = parseFloat(data[0].toFixed(2));
				var top0 = parseFloat(data[1].toFixed(2));
				var canvasWidth = $('#mycanvas').width();
				var canvasHeight = $('#mycanvas').height();
				let scale_h_percent = canvasHeight / imgHeight;
				let scale_w_percent = canvasWidth / imgWidth;
				var left = left0 * scale_w_percent;
				var top = top0 * scale_h_percent;
				var width = parseFloat(data[2].toFixed(2)) - parseFloat(data[0].toFixed(2));
				width = width * scale_w_percent;
				var height = parseFloat(data[3].toFixed(2)) - parseFloat(data[1].toFixed(2));
				height = height * scale_h_percent;
				var zxd = data[4] + "," + data[5] + "," + data[6];
				// console.log(left,top,width,height,num,zxd);
				this.addfabric(left, top, width, height, num, zxd);
			},
			transformaText(data, imgWidth, imgHeight) {
				var left0 = parseFloat(data[0].toFixed(2));
				var top0 = parseFloat(data[1].toFixed(2));
				var canvasWidth = $('#mycanvas').width();
				var canvasHeight = $('#mycanvas').height();
				let scale_h_percent = canvasHeight / imgHeight;
				let scale_w_percent = canvasWidth / imgWidth;
				var left = left0 * scale_w_percent;
				var top = top0 * scale_h_percent;
				var width = data[2];
				var text = new fabric.Textbox(data[3], { //绘制文本
					width: width,
					fontSize: 20,
					left: left,
					top: top,
					fill: "blue",
					stroke: 'blue',
					strokeWidth: 0.1,
				});
				canvas.add(text);
				canvas.setActiveObject(text);
			},
			addfabric(left, top, width, height, num, zxd) {
				var deleteIcon =
					"data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";
				// // console.log(fabric.Object.prototype);
				fabric.Object.prototype.transparentCorners = false;
				fabric.Object.prototype.borderColor = '#409eff';
				fabric.Object.prototype.cornerColor = 'blue';
				fabric.Object.prototype.cornerStyle = 'circle';
				var img = document.createElement('img');
				img.setAttribute('crossOrigin', 'anonymous');
				img.src = deleteIcon;
				var rect = new fabric.Rect({
					wleft: left,
					wtop: top,
					fill: 'rgba(255, 255, 255, 0)',
					width: width,
					height: height,
					objectCaching: false,
					stroke: '#F56C6C',
					strokeWidth: 1,
				});

				var imgElement = document.createElement('img'); //声明我们的图片
				imgElement.setAttribute('crossOrigin', 'anonymous');
				// imgElement.src = '/img/jiantou.png';
				imgElement.src = process.env.VUE_APP_IMGSRC_BASE;
				// // console.log(imgElement);
				var imgInstance = new fabric.Image(imgElement, { //设置图片位置和样子
					left: -50,
					top: -40,
					width: 500,
					scaleX: 0.1,
					scaleY: 0.1,
					height: 200,
					angle: 30 //设置图形顺时针旋转角度
				});
				if (!num && num != 0) {
					num = ''
				} else {
					num = num + 1;
					num = num > 9 ? "" + num : "0" + num;
				}

				var text = new fabric.Text(num, { //绘制文本
					left: 5,
					top: -5,
					fontSize: 14,
					originX: 'center',
					originY: 'center',
					fill: 'red'
				})

				//进行组合
				var group = new fabric.Group([rect, imgInstance, text], {
					left: left - 60,
					top: top - 40,
					backgroundColor: zxd
				})
				canvas.add(group);
				canvas.setActiveObject(group);

				fabric.Object.prototype.controls.deleteControl = new fabric.Control({
					x: 0.5,
					y: -0.5,
					offsetY: 16,
					cursorStyle: 'pointer',
					mouseUpHandler: deleteObject,
					render: renderIcon,
					cornerSize: 24
				});

				function deleteObject(eventData, transform) {
					var target = transform.target;
					var canvas = target.canvas;
					canvas.remove(target);
					canvas.remove(imgInstance);
					canvas.requestRenderAll();
				}

				function renderIcon(ctx, left, top, styleOverride, fabricObject) {
					var size = this.cornerSize;
					ctx.save();
					ctx.translate(left, top);
					ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
					ctx.drawImage(img, -size / 2, -size / 2, size, size);
					ctx.restore();
				}

			},
			setUrlCanvas() {
				this.$nextTick(function() {})
			},
			// canvas画布
			initDraw(url) {
				var that = this;
				if (canvas) {
					// 清空画布
					$('.vanvas-d .canvas-container').remove();
					$('.vanvas-d').prepend(
						'<canvas id="mycanvas" style="border:1px solid #ccc;width: 100%;height: 100%;" ref="mycanvas"></canvas>'
					)
					// 重置偏移量
					movementX = 0;
					movementY = 0;
				}
				// 初始化画布
				canvas = new fabric.Canvas('mycanvas');

				// 设置宽高
				canvas.setHeight($('.vanvas-d').height());
				canvas.setWidth($('.vanvas-d').width());
				if (!url) {
					console.log(this.imageData.url)
					url = this.imageData.url;
				}
				$('.onloadImg').show();
				var nowImgWidth = 0;
				var nowImgHeight = 0;
				this.onloadCanvaImg = true;
				fabric.Image.fromURL(url, (img) => {
					this.onloadCanvaImg = false;
					img.set({
						// 通过scale来设置图片大小，这里设置和画布一样大
						scaleX: canvas.width / img.width,
						scaleY: canvas.height / img.height,
					});
					this.canvasBackImg = img;
					// 设置背景
					canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas));
					canvas.renderAll();
					$('.onloadImg').hide();
					// nowImgWidth = img.width;
					// nowImgHeight = img.height;
					window.electron.getImageDimensions(this.updataList[this.updataIndex].source_path).then((
						result) => {
						nowImgWidth = result.width;
						nowImgHeight = result.height;
						if (this.updataList[this.updataIndex].detection) {
							var canvasHis = this.dataType == 2 ? [] : JSON.parse(this.updataList[this
								.updataIndex].detection);
							this.ysData = canvasHis;
							// ElMessage.success(JSON.stringify(canvasHis));
							if (canvasHis) {
								console.log('绘制数据')
								for (var i = 0; i < canvasHis.length; i++) {
									this.transformationW(canvasHis[i], nowImgWidth, nowImgHeight, i)
								}
							}
						}
					}).catch((error) => {
						console.log('失败--' + error)
						ElMessage.error('失败--' + JSON.stringify(error));
					});
				});
				canvas.on({
					// 鼠标滚动缩放
					"mouse:wheel": (e) => {
						var oldZoom = zoom;
						zoom = (event.deltaY > 0 ? -0.2 : 0.2) + canvas.getZoom();
						zoom = Math.max(1, zoom); //最小为原来的1
						zoom = Math.min(15, zoom); //最大是原来的10倍
						that.nowZoom = zoom;
						// 缩放偏移量
						movementX += (canvas.width / 2) / zoom - (canvas.width / 2) / oldZoom;
						movementY += (canvas.height / 2) / zoom - (canvas.height / 2) / oldZoom;
						// var zoomPoint = new fabric.Point(e.pointer.x, e.pointer.y); // 中心点
						var zoomPoint = new fabric.Point(canvas.width / 2, canvas.height / 2);
						canvas.zoomToPoint(zoomPoint, zoom);
					},
				})

				canvas.on('mouse:up', (e) => {
					this.panning = false;
					endX = e.pointer.x;
					endY = e.pointer.y;
					var widthX = endX - startX > 0 ? endX - startX : startX - endX;
					var heightY = endY - startY > 0 ? endY - startY : startY - endY;
					// 减去背景平移位置
					startX = startX / zoom - movementX;
					startY = startY / zoom - movementY;
					if (this.isAdd) {
						this.addfabric(startX, startY, widthX / zoom, heightY / zoom);
						this.isAdd = false;
					}
				});
				// 鼠标按下
				canvas.on('mouse:down', (e) => {
					this.panning = true;
					startX = e.pointer.x;
					startY = e.pointer.y;
				});
				canvas.on('mouse:move', (e) => {
					if (this.isMove && this.panning && e && e.e) {
						// // console.log(e);
						var units = 10;
						movementX += (e.e.movementX) / zoom;
						movementY += (e.e.movementY) / zoom;
						var delta = new fabric.Point(e.e.movementX, e.e.movementY);
						canvas.relativePan(delta);
					}
				})




			},
			collectRight() {
				this.rightIsOpen = !this.rightIsOpen
			},
			getGlrw() {
				var link_dept = '';
				// if (sessionStorage.getItem('type') == 0 || sessionStorage.getItem('type') == 1 || sessionStorage.getItem(
				// 		'type') == 2) {
				// 	link_dept = sessionStorage.getItem('deptId');
				// } else if (sessionStorage.getItem('type') == 3) {
				// 	link_dept = sessionStorage.getItem('link_dept');
				// }
				link_dept = sessionStorage.getItem('deptId');
				this.$axios.post('/papaver/linkTask', {
						userId: sessionStorage.getItem('userId'),
						type: sessionStorage.getItem('type'),
						link_dept: link_dept
					})
					.then(res => {

						if (res.data.code != 666) {
							ElMessage.error(res.data.msg);
							return
						}
						this.glrwList = res.data.data;
						this.ckGlrwList = res.data.data;
						this.ckGlrwList = [{
							taskName: '全部',
							taskId: ''
						}];
						for (var i = 0; i < res.data.data.length; i++) {
							this.ckGlrwList.push(res.data.data[i])
						}
					})
					.catch(error => {
						console.log('error:', error)
					})
			},
			aavvc() {},



			uploadProgress(event, file, fileList) {
				this.percentage0 = parseFloat(event.percent.toFixed(2));
			},
			uploadProgress1(event, file, fileList) {
				this.percentage1 = parseFloat(event.percent.toFixed(2));
			},
			uploadProgress2(event, file, fileList) {
				this.percentage2 = parseFloat(event.percent.toFixed(2));
			},

			// 获取图片信息
			getImgBase(dybh, isLook) {
				this.isGetImg = true;
				this.imageData.thumbFileUrl = ''
				this.imageData1.thumbFileUrl = ''
				this.imageData2.thumbFileUrl = ''
				this.$axios.post('/papaver/file', {
						userId: sessionStorage.getItem('userId'),
						type: sessionStorage.getItem('type'),
						dybh: dybh,
					})
					.then(res => {
						this.isGetImg = false;
						var data = res.data.data;
						console.log(data)
						if (res.data.code != 200) {
							ElMessage.error(res.data.msg);
							return
						}
						this.jcxxImgnUM = 0;
						// 稽查信息
						var jcdd = res.data.jcData;
						for (var i = 0; i < jcdd.length; i++) {
							this.imgListJc.push(jcdd[i].url);
							this.jcxxImg.push(jcdd[i].thumbUrl);
							this.jcxxImgnUM = this.jcxxImgnUM + 1;
						}
						// 查看图片
						for (var i = 0; i < data.length; i++) {
							this.imgList.push(data[i].sbUrl)
						}
						// 原图
						for (var i = 0; i < data.length; i++) {
							this.sourceUrlList.push(data[i].sourceUrl)
						}
						console.log(this.sourceUrlList)
						this.getImgData = data;
						if (data[0]) {
							this.flieidList.one = data[0].fileId;
							this.canvasSVG.one = data[0].sbUrl;
							this.flieRouteList.one = data[0].filePath;

							if (data[0].sbUrl) {
								this.imageData.thumbFileUrl = data[0].sbUrl;
							} else {
								this.imageData.thumbFileUrl = data[0].thumbUrl;
							}
							if (isLook) {
								this.imageData.url = data[0].sbUrl;
							} else {
								this.imageData.url = data[0].url;
								if (data[0].sbxx) {
									this.canvasData.one = data[0].sbxx;
								}
							}
						}
						if (data[1]) {
							this.flieidList.two = data[1].fileId;
							this.canvasSVG.two = data[1].sbUrl;
							this.flieRouteList.two = data[0].filePath;

							if (data[1].sbUrl) {
								this.imageData1.thumbFileUrl = data[1].sbUrl;
							} else {
								this.imageData1.thumbFileUrl = data[1].thumbUrl;
							}

							if (isLook) {
								this.imageData1.url = data[1].sbUrl;
							} else {
								this.imageData1.url = data[1].url;
								if (data[1].sbxx) {
									this.canvasData.two = data[1].sbxx;
								}
							}
						}
						if (data[2]) {
							this.flieidList.three = data[2].fileId;
							this.canvasSVG.three = data[2].sbUrl;
							this.flieRouteList.three = data[0].filePath;

							if (data[2].sbUrl) {
								this.imageData2.thumbFileUrl = data[2].sbUrl;
							} else {
								this.imageData2.thumbFileUrl = data[2].thumbUrl;
							}

							if (isLook) {
								this.imageData2.url = data[2].sbUrl;
								this.imageData2.thumbFileUrl = data[2].sbUrl;
							} else {
								this.imageData2.url = data[2].url;
								this.imageData2.thumbFileUrl = data[2].sbUrl;
								if (data[2].sbxx) {
									this.canvasData.three = data[2].sbxx;
								}
							}
						}
						// console.log(this.canvasData);
					})
					.catch(error => {
						this.isGetImg = false;
						console.log('error:', error)
					})
			},

			async updataChangePage() {
				try {
					this.updataList = await this.getUpdataList();
					setTimeout(() => {
						this.updateIndexAndResetData(0)
					}, 500)
				} catch (error) {
					console.error('获取数据失败:', error);
					ElMessage.error({
						message: '数据加载失败',
						description: error.message,
						duration: 5000
					});
				}
			},
			async getUpdataList() {
				this.loading = true
				this.loadingText = '数据列表同步中。。。'
				if (this.dataType == 1) {
					// 疑似
					var select_sql =
						`SELECT * FROM records WHERE local_id = '${escape(this.local_id)}'
					  AND detection != '[]' AND dybh ISNULL LIMIT ${(Number(this.updataNowPage) - 1) * this.updataLimit}, ${this.updataLimit}`
				} else if (this.dataType == 0) {
					// 未识别 
					var select_sql = `SELECT * FROM records WHERE local_id = '${escape(this.local_id)}'
					  AND detection = '[]' LIMIT ${(Number(this.updataNowPage) - 1) * this.updataLimit}, ${this.updataLimit}`
				} else if (this.dataType == 2) {
					// 待稽查
					var select_sql =
						`SELECT * FROM records WHERE local_id = '${escape(this.local_id)}'
					  AND detection != '[]' AND dybh NOTNULL LIMIT ${(Number(this.updataNowPage) - 1) * this.updataLimit}, ${this.updataLimit}`
				}
				try {
					const result = await window.electron.query(select_sql);
					this.loading = false
					return result
				} catch (error) {
					ElMessage.error({
						message: '查询失败',
						description: error.toString(),
						duration: 5000
					});
					throw error; // 重新抛出错误
				}
			},

			async changeType(val) {
				this.dataType = val;
				this.updataPage = 0
				this.updataList = []
				this.updataNowPage = 1
				if (val == 1) {
					this.updataTotal = this.ysNum
				} else if (val == 0) {
					this.updataTotal = this.wjcNum
				} else if (val == 2) {
					this.updataTotal = this.sbjcNum
				}

				// updataTotal
				try {
					this.updataList = await this.getUpdataList();
					setTimeout(() => {
						this.updateIndexAndResetData(0)
					}, 500)
				} catch (error) {
					console.error('获取数据失败:', error);
					ElMessage.error({
						message: '数据加载失败',
						description: error.message,
						duration: 5000
					});
				}
			},

			async previous() {
				console.log('上一张')
				if (this.updataIndex == 0) {
					if (this.updataNowPage == 1) {
						ElMessage.warning('已经是第一张了')
					} else {
						this.updataNowPage--
						this.updataList = await this.getUpdataList();
						setTimeout(() => {
							this.updateIndexAndResetData(0)
						}, 500)
					}
				} else {
					this.updateIndexAndResetData(this.updataIndex - 1);
				}
			},
			async nextSheet() {
				console.log('下一张')
				if (this.updataIndex == this.updataList.length - 1) {
					const hasRemainder = Number(this.updataTotal) / Number(this.updataNowPage)
					if (hasRemainder > 7) {
						console.log('后边还有')
						this.updataNowPage++
						this.updataList = await this.getUpdataList();
						setTimeout(() => {
							this.updateIndexAndResetData(0)
						}, 500)
					} else {
						console.log('最后一页')
						ElMessage.warning('已经是最后一张了')
					}
				} else {
					this.updateIndexAndResetData(this.updataIndex + 1);
				}
			},
			// 还原
			handleEdit(index, row) {
				this.rowData = row;
				this.isEdit = true;
				this.khForm.jcwz = row.address;
				this.khForm.zbxx = row.gps;
				this.khForm.sfqr = row.state;
				this.khForm.sldj = row.level;
				this.khForm.glrw = row.taskId;
				this.khForm.glrwName = row.taskName;
				this.isLook = false;
				this.nowCenter = row.gps.split(",");
				this.drawerTitle = "修改任务--" + row.dybh;
				var isNullhlrw = true;
				for (var i = 0; i < this.glrwList.length; i++) {
					if (this.glrwList[i].taskId == row.taskId) {
						isNullhlrw = false;
					}
				};
				if (isNullhlrw) {
					this.glrwList.push({
						taskId: row.taskId,
						taskName: row.taskName
					})
				}
				// 获取图片
				this.getImgBase(row.dybh, false);
				this.drawerkh = true;
			},
			handleDelete(index, row) {
				this.$axios.post('/papaver/del', {
						userId: sessionStorage.getItem('userId'),
						type: sessionStorage.getItem('type'),
						dybh: row.dybh,
					})
					.then(res => {
						if (res.data.code != 200) {
							ElMessage.error(res.data.msg);
							return
						}
						ElMessage.success(res.data.msg);
						this.tableData.splice(index, 1);
					})
					.catch(error => {
						console.log('error:', error)
					})
			},

			khClick() {
				this.drawerTitle = '信息上报';
				// this.isEdit = false;
				// this.isLook = false;
				this.drawerkh = true;

				this.dialogEdit = true;
			},

			setCenter(location, adderss) {
				if (this.nowCenter) {

				}
			},
			gpsToAdderss() {
				let that = this;
				var location = this.map.getCenter();
				if (!location) {
					return
				}
				var geocoder = new AMap.Geocoder({
					radius: 500 //范围，默认：500
				});
				geocoder.getAddress([location.lng, location.lat], function(status, result) {
					that.ssdwForm.ditusou = result.regeocode.formattedAddress;
				});
			},
			resetFormkh(formName) {
				this.khForm = {
					jcwz: '',
					zbxx: '',
					sfqr: 0,
					sldj: '1~50',
					glrw: '',
				};
				this.imageData = {
					url: ''
				};
				this.imageData1 = {
					url: ''
				};
				this.imageData2 = {
					url: ''
				};
				this.canvasData = {
					one: '',
					two: '',
					three: ''
				};
				this.flieidList = {
					one: '',
					two: '',
					three: ''
				};
				this.percentage0 = 0,
					this.percentage1 = 0,
					this.percentage2 = 0,
					// 识别结果重置
					this.eitdItemText = '';
				this.ysData = [];
				this.$refs.khForm.clearValidate();

				this.showViewer = false;
				this.imgList = [];
				this.sourceUrlList = [];
				this.viewerIndex = 0;

				this.showViewerJc = false;
				this.imgListJc = [];
				this.viewerIndexJc = 0;
				this.getImgData = [];
			},

			resetForm1(formName) {
				this.$refs[formName].resetFields()
			},
			async getKhList() {
				var filterData = ''
				if (this.ckSelectTaskId) {
					filterData = ' where task_id = "' + this.ckSelectTaskId + '"'
				}
				try {
					const tableData = await window.electron.query(
						"SELECT local_id, dybh, task_id, task_name, storage_path, add_time, source_path, COUNT(local_id) AS count, COUNT( CASE WHEN detection NOTNULL THEN 1 END) AS save_path_count FROM records " +
						filterData + " GROUP BY local_id ORDER BY add_time DESC LIMIT " +
						(Number(this.tableNowPage) - 1) * 10 + ", " + this.limit +
						""
					);
					if (tableData.length == 0) {
						return
					}
					const tableTotal = await window.electron.query(
						"SELECT COUNT(DISTINCT local_id) AS count FROM records" + filterData
					);
					this.tableTotal = tableTotal[0]?.count || 0;
					this.tableData = tableData.map(item => {
						// 1. 安全处理数值转换（防止字符串类型的数字）
						const savePathCount = Number(item.save_path_count) || 0;
						const totalCount = Number(item.count) || 0;

						// 2. 添加除数非零校验
						const percentage = totalCount > 0 ?
							Math.round((savePathCount / totalCount) * 10000) / 100 // 保留2位小数
							:
							0; // 当count为0时返回0%

						// 3. 使用对象展开符保留其他属性（非破坏性修改）
						return {
							...item,
							save_path_percentage: percentage
						};
					});
				} catch (error) {
					ElMessage.error({
						message: '查询失败',
						description: error.toString(),
						duration: 5000
					});
					throw error; // 重新抛出错误
				}
			},

			selectCkRwPl(val) {
				this.ckSelectTaskId = val;

				this.getKhList();
			},

			searchBtn() {
				this.tableNowPage = 1;
				this.getKhList(this.tablekwd)
			},

			djYjBtn(show, type) {
				console.log(show)
				if (sessionStorage.getItem('expTime') < this.getCurrentDateTime()) {
					ElMessage.error('使用期限已到，请及时联系技术人员。');
					return
				}
				this.yjTitle = type
				this.uploadFistPlData.taskId = ''
				this.uploadPath = ''
				this.storagePath = ''
				if (show) {
					this.modalName = 'yjsb';
					this.fileList = [];
					this.pcUploadList = [];
					this.isTest = show;
				} else {
					console.log('清空数据')
					this.modalName = ''
					this.fileList = []
					this.uploadFistPlData.taskId = ''
					this.uploadPath = ''
					this.storagePath = ''
				}
				// this.getGlrw();
				console.log(this.modalName)
			},
			uploadXzml() {
				if (!this.uploadFistPlData.taskId) {
					ElMessage.warning('请选择关联任务!')
					return
				}
				window.electron.chooseFolderAndGenerateTree().then((result) => {
					this.fileTree = result.fileData.imgList
					this.uploadPath = result.fileData.fileTree.path
				}).catch((error) => {
					console.log('失败--' + error)

				});
			},
			uploadXzwj() {
				if (!this.uploadFistPlData.taskId) {
					ElMessage.warning('请选择关联任务!')
					return
				}
				window.electron.selectImage().then((result) => {
					console.log(result)
					this.uploadPath = result
				}).catch((error) => {
					console.log('失败--' + error)

				});
			},
			getCurrentDateTime() {
				const now = new Date();
				const year = now.getFullYear();
				const month = String(now.getMonth() + 1).padStart(2, '0');
				const day = String(now.getDate()).padStart(2, '0');

				const hours = String(now.getHours()).padStart(2, '0');
				const minutes = String(now.getMinutes()).padStart(2, '0');
				const seconds = String(now.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			async userLook(row) {
				this.modalName = 'yjxq';
				this.local_id = row.local_id
				this.updataNowPage = 1
				this.dataType = 1;
				this.loadingText = '数据加载中。。。'
				setTimeout(() => {
					this.getStatData()
				}, 200);
			},
			async getStatData() {
				var canvasHeight = $('.vanvas-d').height() - 50
				this.updataLimit = (canvasHeight / 75) | 0
				const selectCount = await window.electron.query(
					"SELECT SUM( CASE WHEN detection = '[]' THEN 1 ELSE 0 END) AS empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh ISNULL THEN 1 ELSE 0 END ) AS non_empty_array_count, SUM( CASE WHEN detection != '[]' AND dybh NOTNULL THEN 1 ELSE 0 END ) AS non_empty_array_count2, COUNT(*) AS total_count FROM records WHERE local_id = '" +
					this.local_id + "'"
				);
				this.wjcNum = selectCount[0].empty_array_count
				this.ysNum = selectCount[0].non_empty_array_count
				this.updataTotal = selectCount[0].non_empty_array_count
				this.sbjcNum = selectCount[0].non_empty_array_count2
				this.sbNum = selectCount[0].total_count
				// wjcNum
				try {
					this.updataList = await this.getUpdataList();
					setTimeout(() => {
						this.updateIndexAndResetData(0)
					}, 200);
				} catch (error) {
					console.error('获取数据失败:', error);
					ElMessage.error({
						message: '数据加载失败',
						description: error.message,
						duration: 5000
					});
				}
			},

			truncateToThreeDecimals(num) {
				// 1. 将数字转为字符串
				const numStr = num.toString();
				// 2. 检查是否有小数点
				const decimalIndex = numStr.indexOf('.');
				// 3. 如果没有小数点，直接返回原数字
				if (decimalIndex === -1) return num;
				// 4. 截取整数部分 + 前3位小数
				const truncatedStr = numStr.slice(0, decimalIndex + 4);
				// 5. 转为数字并乘以100（避免浮点数运算）
				const result = parseFloat(truncatedStr) * 100;
				// 6. 用 toFixed 去掉多余的浮点误差（如 88.2000000000 → 88.2）
				return parseFloat(result.toFixed(10));
			},

			// const dialogVisible = ref(false);

			async exportDoc(row) {
				this.loadingText = '报告生成中。。。'
				this.loading = true
				try {
					let pointNum = 0
					const result = await window.electron.query(
						"SELECT local_id, task_name, task_id, SUM( CASE WHEN detection != '[]' AND dybh ISNULL THEN 1 ELSE 0 END) AS ysNum, SUM( CASE WHEN detection != '[]' AND dybh NOTNULL THEN 1 ELSE 0 END ) AS qdNum, COUNT(*) AS picNum FROM records WHERE local_id = '" +
						row.local_id + "'"
					);
					const records = await window.electron.query(
						"SELECT * FROM records WHERE local_id = '" + row.local_id +
						"' AND detection != '[]' ORDER BY dybh DESC"
					);
					// 2. 使用Promise.all处理异步请求
					const imgList = await Promise.all(records.map(async (record) => {
						const {
							source_path: name,
							save_path: imgUrl,
							detection: detectionStr,
							dybh
						} = record;
						// 3. 初始化默认值
						let gps = '--';
						let address = '--';

						// 4. 获取位置信息
						if (dybh) {
							try {
								const response = await this.$axios.post('/papaver/list', {
									dyzt: '2',
									link_dept: 'gen',
									search: dybh,
									type: sessionStorage.getItem('type'),
									userId: sessionStorage.getItem('userId'),
								});

								if (response.data?.code === 200 && response.data.data
									?.length > 0) {
									gps = response.data.data[0].gps || gps;
									address = response.data.data[0].address || address;
								}
							} catch (error) {
								console.error('获取位置信息失败:', error);
								// 保持默认值，不中断流程
							}
						}

						// 5. 安全解析JSON数据
						let detection = [];
						try {
							detection = JSON.parse(detectionStr).rect ? JSON.parse(
									detectionStr)
								.rect : JSON.parse(detectionStr);
							pointNum += Array.isArray(detection) ? detection.length : 0;
						} catch (error) {
							console.error('解析detection失败:', error);
						}
						console.log(detection)
						// 6. 处理检测数据
						const infoList = detection.map((item, index) => ({
							name: index + 1,
							// number: Math.round(item[5] * 100) + '%' || '--'
							number: this.truncateToThreeDecimals(item[5]) + '%' || '--'
						}));
						return {
							imgUrl,
							name,
							number: detection.length,
							gps,
							address,
							infoList
						};
					}));

					console.log('处理结果:', imgList);
					// 5. 显示处理结果
					const startSchemeTemplate = ref({
						taskName: result[0].task_name,
						taskId: result[0].local_id,
						picNum: result[0].picNum,
						ysNum: result[0].ysNum,
						qdNum: result[0].qdNum,
						pointNum: pointNum,
						dateTime: this.getCurrentDateTime(),
						exportList: imgList
					});
					const imgSize = ref({
						imgUrl: [325, 250],
					});
					const htmlTitle = ref('禁种铲毒识别报告');

					// 调用示例
					exportWordImage(
						// https://zcjzcd.com/api/public/doc/001.docx
						"https://zcjzcd.com/api/public/doc/001.docx?" + (new Date()).valueOf(),
						startSchemeTemplate.value,
						htmlTitle.value,
						imgSize.value,
						(progress) => {
							console.log(`进度: ${progress}%`);
							console.log(progress)
							this.progress = progress
							console.log(this.progress)
							if (this.progress == 100) {
								this.loading = false
								this.$message({
									message: '生成成功',
									type: 'success'
								});
							}
						}
					);
					return {
						result,
						imgList
					};

				} catch (error) {
					console.error('获取文档列表失败:', error);
					this.$message.error('获取文档列表失败');
					throw error;
				}


			},


			async again(row) {
				this.upload_local_id = row.local_id;
				this.storagePath = row.storage_path;
				this.upload_storage_path = row.storage_path;
				this.upload_task_name = row.task_name
				this.upload_task_id = row.task_id
				this.fileTree = []
				const unrecognized = await window.electron.query(
					"SELECT * FROM records WHERE  local_id = '" + this.upload_local_id +
					"' AND detection ISNULL");
				this.fileTree = unrecognized.map(item => ({
					path: item.source_path
				}));

				await this.enableIt('again')
			},
			async enableIt(enableType) {
				try {
					const filesToProcess = this.fileTree.length == 0 ? [{
						path: this.uploadPath
					}] : this.fileTree

					if (filesToProcess.length == 0) {
						ElMessage.warning('请选择要识别的资源')
						return
					}
					if (this.storagePath == '') {
						ElMessage.warning('请选择文件的存储路径')
						return
					}
					if (this.isProcessing) {
						ElMessage.warning('已有任务正在处理中');
						return
					}
					this.isProcessing = true;

					this.modalName = ''
					this.loadingText = '图片上传中'
					this.loading = true
					if (enableType == 'submit') {
						this.local_id = uuidv4()
						this.upload_task_name = this.uploadFistPlData.taskName
						this.upload_task_id = this.uploadFistPlData.taskId
						this.upload_local_id = this.local_id
						this.upload_storage_path = this.storagePath
						for (const [index, file] of filesToProcess.entries()) {
							if (!file.path) continue;
							const insert_sql =
								`INSERT INTO records (source_path, local_id) VALUES ('${file.path}','${this.upload_local_id}')`
							await window.electron.Insert(insert_sql)

						}
					}
					for (const [index, file] of filesToProcess.entries()) {
						if (!file.path) continue;
						await this.handleRunInference(file.path, filesToProcess.length);
					}
				} catch (error) {
					// ElMessage.error(`处理中止: ${error}`);
				} finally {
					// ElMessage.success(`图片识别完成`);
					if (this.isProcessing) {
						this.isProcessing = false;
						this.uploadFistPlData.taskId = ''
						this.uploadPath = ''
						this.storagePath = ''
					}
				}
			},
			async handleRunInference(imagePath) {
				try {
					if (!imagePath) {
						ElMessage.warning("无效的文件路径");
						return;
					}
					// 执行推理
					// 1. 获取检测结果
					const detections = await window.electron.runInference(imagePath);

					// 2. 安全处理检测结果
					const detectionsJson = detections?.length > 0 ? JSON.stringify(
						detections) : '[]';
					if (detections?.error) {
						throw new Error(detections.error);
					}

					const savePath = await this.saveRectImg(
						imagePath,
						JSON.stringify(detections),
						this.upload_storage_path + '\\' + this.upload_local_id
					);
					// const update_sql =
					// 	`update records set dybh='${upload_result.dybh}',save_path='${savePath}' where local_id='${this.local_id}' and source_path='${fileUrl}'`
					// await window.electron.update(update_sql)

					const update_sql =
						`update records set detection='${detectionsJson}',task_id='${this.upload_task_id}',save_path='${savePath}',task_name='${this.upload_task_name}', storage_path='${this.upload_storage_path}', add_time='${this.getCurrentDateTime()}' where local_id='${this.upload_local_id}' and source_path='${imagePath}'`
					await window.electron.update(update_sql)
					const index = this.tableData.findIndex(item => item.local_id == this
						.upload_local_id);
					// 2. 添加错误处理和边界检查
					if (index === -1) {
						this.getKhList();
					} else {
						console.log('找到的项目索引:', index);
						const countData = await window.electron.query(
							"SELECT COUNT(local_id) AS count, COUNT( CASE WHEN detection NOTNULL THEN 1 END) AS save_path_count FROM records WHERE local_id = '" +
							this.upload_local_id + "' GROUP BY local_id"
						);
						const savePathCount = Number(countData[0].save_path_count) || 0;
						const totalCount = Number(countData[0].count) || 0;
						// 2. 添加除数非零校验 
						const percentage = totalCount > 0 ?
							Math.round((savePathCount / totalCount) * 10000) / 100 // 保留2位小数
							:
							0; // 当count为0时返回0%
						Object.assign(this.tableData[index], {
							save_path_count: countData[0].save_path_count,
							save_path_percentage: percentage,
						});
					}
					if (this.loading) {
						this.loading = false
					}
				} catch (error) {
					ElMessage.error({
						message: `文件处理失败: ${error}`,
						description: error.message,
						duration: 5000
					});
					// 允许继续处理后续文件
					return {
						success: false,
						error: error.message
					};
				}
			},

			downloadMl() {
				window.electron.openFolder().then((result) => {
					console.log(result)
					this.storagePath = result;
				}).catch((error) => {
					console.log('失败--' + error)
					ElMessage.error(JSON.stringify(error));
				});
			},
			changePage() {
				this.getKhList();
			},
			//心跳检测
			heartCheck() {
				var timeout = 540000; //9分钟发一次心跳
				var timeoutObj = null;
				var serverTimeoutOb = null;
			}
		},
		watch: {
			filterText(val) {
				this.$refs.tree.filter(val)
			},
		},
		mounted() {
			// 客户列表)
			// this.getDocList()
			if (sessionStorage.getItem('expTime') < this.getCurrentDateTime()) {
				ElMessage.error('使用期限已到，请及时联系技术人员。');
				return
			} else {
				console.log('不到期')
			}
			this.getKhList();
			this.getGlrw();
		},
		beforeUnmount() {
			// 关闭连接
			// this.socket.close()
			// 销毁 websocket 实例对象
			// this.socket = null
		}
	}

	function poiPickerReady(poiPicker) {
		window.poiPicker = poiPicker;
		var marker = new AMap.Marker();
		var infoWindow = new AMap.InfoWindow({
			offset: new AMap.Pixel(0, -20)
		});
	}
</script>

<style scoped>
	.el-row {
		height: 100%;
		flex-wrap: nowrap !important;
	}

	.left {
		min-width: 16.667%;
		margin-right: 10px;
	}

	.right {
		width: 100%;
		flex: 1;
	}

	.custom-tree-node {
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	.filter-input {
		width: 100%;
		display: flex;
		height: 50px;
		align-items: center;
		margin-bottom: 15px;
	}

	.right-title {
		display: flex;
		width: 100%;
		justify-content: space-between;
	}

	.drawer-div {
		width: 100%;
		height: calc(100% - 50px);
		/* height: 850px; */
		box-sizing: border-box;
		padding: 10px;
		display: flex;
	}

	.gd-ditu {
		width: 100%;
		height: 400px;
		border-radius: 14px;
		position: relative;
	}

	.lebel-w {
		width: 100%;
		display: block;
		text-align: left;
		line-height: 45px;
		font-size: 14px;
		padding-left: 12px;
	}

	.mapList {
		width: 100%;
		position: absolute;
		top: 40px;
		left: 0;
		z-index: 99;
		background: #fff;
		text-align: left;
		list-style: none;
	}

	.mapList>li {
		box-sizing: border-box;
		padding-left: 15px;
	}

	.mapList>li:hover {
		background: #f2f4f5;
	}

	.ditu-center {
		width: 50px;
		height: 50px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 98;
	}

	.right-main {
		width: 100%;
		height: calc(100% - 140px);
		overflow: auto;
	}

	.radius-w {
		width: 25px;
		height: 25px;
		border-radius: 50%;
		line-height: 28px;
		text-align: center;
		/* display: flex;
		align-items: center;
		justify-content: center; */
		cursor: pointer;
		color: #FFFFFF;
	}

	.drawer-left {
		flex: 1;
		position: relative;
	}

	.mapSz {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		z-index: 999;
		font-size: 60px;
		color: #67C23A;
	}

	.drawer-right {
		width: 40%;
		overflow-y: auto;
	}

	#mapDiv {
		width: 100%;
		height: 100%;
	}

	.vanvas-d {
		border: 1px solid #ccc;
		position: relative;
		overflow: hidden;
	}

	.BasicTextResult {
		top: 0;
		right: 0;
		z-index: 12;
		width: 300px;
		height: 100%;
		display: flex;
		overflow: hidden;
		position: absolute;
		color: #fff;
	}

	.BasicTextResult-leftIcon {
		width: 15px;
		height: 100%;
		position: relative;
		transition: all .5s linear 0ms;
		cursor: pointer;
	}

	.leftIconDiv {
		height: 100px;
		border-right: 15px solid rgba(0, 0, 0, .4);
		border-top: 10px solid transparent;
		border-bottom: 10px solid transparent;
		position: absolute;
		top: 216px;
		left: 0;
	}

	.leftIconDiv .leftIcon {
		font-size: 6px;
		position: absolute;
		top: 40px;
		left: 4px;
		color: #fff;
	}

	.BasicTextResult-textResult {
		width: 285px;
		height: 100%;
		padding: 16px;
		overflow-y: auto;
		transition: all .5s linear 0ms;
		background: rgba(0, 0, 0, .4);
		box-sizing: border-box;
		text-align: left;
	}

	.CentreResult-title {
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		line-height: 31.22px;
		clear: both;
		text-align: left;
		text-indent: 1em;
	}

	.CentreResult-Div-titileSpan {
		width: 80px;
		float: left;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		line-height: 31.22px;
	}

	.CentreResult-Div-resultSpan {
		margin-left: 10px;
		width: 130px;
		float: left;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #fff;
		letter-spacing: 0;
		line-height: 31.22px;
	}

	.BasicTextResult.open {
		transform: translateX(285px);
		transition: all .5s linear 0ms;
	}

	.BasicTextResult.close {
		transform: translateX(0);
		transition: all .5s linear 0ms;
	}

	.basic-text {
		height: 22px;
		width: 85px;
		font-family: PingFangSC-Medium;
		font-size: 16px;
		color: #fff;
		margin-bottom: 10px;
		letter-spacing: 0;
	}

	.shb-smc {
		/* display: none; */
		width: 100%;
		height: 0;
		position: absolute;
		top: 0;
		left: 0;
		background-image: linear-gradient(to top, #3a98df, #42b0ff, #ffffff, #ffffff);
		z-index: 99;
		opacity: 0.5;
		animation: shbSmc 2s linear 0s infinite;
	}

	.onloadImg {
		width: 30%;
		height: 30%;
		/* background: url(../../public/img/loadBg.png) no-repeat;
		background-position: center top;
		background-size: auto 100%; */
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: none;
	}

	.eitd-item {
		width: 6vw;
		text-align: center;
		cursor: pointer;
		margin-top: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.eitd-item img {
		width: 2vw;
	}

	.isEitd-item {
		background-color: aliceblue;
	}

	.plsc-card {
		width: 100%;
		height: 500px;
		overflow-y: auto;
		margin: 15px 0;
		border: 2px dashed #CCCCCC;
		border-radius: 14px;
		position: relative;
	}

	.plsc-card-text {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-size: 20px;
		font-weight: bold;
		letter-spacing: 2px;
		color: #ccc;
	}

	.sbwc-text {
		color: #1ba57b !important;
	}

	.sbwc-text .svg-text {
		color: #1ba57b !important;
	}

	@keyframes shbSmc {
		from {
			height: 0;
		}

		to {
			height: 36vw;
		}
	}

	.image-viewer-footer {
		width: 100%;
		position: absolute;
		top: 10px;
		left: 10px;
		text-align: center;
		display: flex;
		justify-content: center;
		/* 根据背景色调整文字颜色 */
		/* 其他样式... */
	}

	.cell .el-tooltip {
		white-space: normal;
	}

	.el-table .cell.el-tooltip {
		white-space: normal;
	}

	.el-table th.el-table__cell>.cell {
		color: #000000;
	}
</style>